/**
 * 管理动态全局变量
 */

import loginFetch from "@/api/loginFetch";
import gptFetch from "@/api/gptFetch";
import api from "@/api";
import platform from "./ENUMPlatform";

const state = {
  gptConfigDatas: {},
  gptModels: [],
  tool_languages: null,
  allCountry: null,
};
const mutations = {
  SET_TOOL_LANGUAGES(state, data) {
    state.tool_languages = data;
  },
  // 缓存 AI 模型数据
  setGptModels(state, data) {
    state.gptModels = data;
  },
  // 缓存全局配置数据
  setGptConfigData(state, data) {
    state.gptConfigDatas = data;
    // 平台 暂时由前端控制。 后续如果 sql的查询与平台一致 用后端返回的。
    state.gptConfigDatas.p_c_m_platform_config = platform.platform_config;
  },
  SET_ALL_COUNTRIES(state, data) {
    state.allCountry = data;
  },
};
const actions = {
  /**
   * 获取模型数据
   * @param {*} { commit }
   */
  async getGptModels({ commit }) {
    try {
      const res = await loginFetch.getGptModels();
      commit("setGptModels", res.data.data);
    } catch (error) {
      console.error("Error fetching GPT models:", error);
      throw error;
    }
  },
  /**
   * 获取全局配置数据
   * @param {*} { commit }
   */
  async getGptConfigDatas({ commit }) {
    try {
      const res = await loginFetch.getGptConfigDatas();
      commit("setGptConfigData", res.data);
    } catch (error) {
      console.error("Error fetching GPT config data:", error);
      throw error;
    }
  },
  /**
   * 获取翻译相关语种数据
   * @param {*} { commit }
   */
  async getToolLanguages({ commit }) {
    try {
      const res = await gptFetch.getToolLanguages();
      commit("SET_TOOL_LANGUAGES", res.data);
    } catch (error) {
      console.error("Error fetching getToolLanguages:", error);
      throw error;
    }
  },

  /**
   * 获取所有的国家数据
   * @param {*} { commit }
   */
  async getAllCountry({ commit }) {
    try {
      const res = await api.get_country_language();
      commit("SET_ALL_COUNTRIES", res.data);
    } catch (error) {
      console.error("Error fetching tool_languages:", error);
      throw error;
    }
  },
};
const getters = {
  gpt_config_datas: (state) => state.gptConfigDatas,
  gpt_models: (state) => state.gptModels,
  tool_languages: (state) => state.tool_languages,
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
